export const PREF_KEYS = {
  DATASOURCE: 'datasource',
  RECENT_METRICS: 'recent-metrics',
  BOOKMARKS: 'bookmarks',
  METRIC_PREFS: 'metric-prefs',
  BREAKDOWN_SORTBY: 'breakdown.sortby',
  SIDEBAR_SECTION: 'sidebar.section',
};
